import React from 'react'
import Button from '@material-ui/core/Button'

class CountDownButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
        buttonText: this.props.text,
        isCountDownEnd: true
    }
    this.countDown = this.countDown.bind(this)
    this.onTimeChange = this.onTimeChange.bind(this)
    this.onPress = this.onPress.bind(this)
  }

  countDown() {
    let time = this.props.time
    this.setState({ isCountDownEnd: false })
    this.timer && clearInterval(this.timer)
    this.onTimeChange(time)
    this.timer = setInterval(() => {
        if (time > 0) {
            time--
            this.onTimeChange(time)
        } else {
            this.timer && clearInterval(this.timer)
            this.timer = null
            this.setState({ isCountDownEnd: true })
        }
    }, 1000)
  }

  onTimeChange(time) {
    const { onChange } = this.props
    if (onChange) {
        var newText = onChange(time)
        if (newText !== this.state.buttonText) {
            if (!newText) {
                this.setState({ isCountDownEnd: true })
                newText = this.props.text
            }
            this.setState({ buttonText: newText })
        }
    }
  }

  onPress = () => {
    const { onPress, disabled } = this.props
    if (disabled || !onPress || this.timer) return
    onPress();
    this.countDown()
  }
  componentWillUnmount() {
    this.timer && clearInterval(this.timer)
  }
  render() {
      const {isCountDownEnd} = this.state
      const {disabled} = this.props
    return (
        <Button
            disabled={disabled}
            onClick={this.onPress.bind(this)}
            color={ isCountDownEnd ? 'primary' : 'inherit' }
        >
          {this.state.buttonText}
        </Button>
    )
  }
}

export default CountDownButton



// WEBPACK FOOTER //
// ./src/uis/countDownButton.js